import React, { memo } from 'react';
import UserProps from '../../proptypes/user';
import style from '../../style/components/profile/PersonalProfile.module.scss';
import UpdateAddressButton from '../UpdateAddressButton';
import UpdateNameButton from '../UpdateNameButton';
import Card from '../Card';
import {
  addressLine1,
  addressLine2,
  isEmptyAddress,
} from '../../utils/address';
import { formatPhone } from '../../utils/phone';

const PersonalProfile = ({ user }) => {
  const noName = !user.fname && !user.lname;
  const noAddress = isEmptyAddress(user);
  const noPhone = !user.phone;

  return (
    <Card
      title="Personal Profile"
      icon={<idme-icon name="user" color="stone" size="large" />}
      className={style.card}
    >
      {noName && user.can_request_name_change ? null : (
        <>
          <section>
            <div>
              <h4 className={style.subtitle}>Name</h4>
              <p>{noName ? 'No name' : `${user.fname} ${user.lname}`}</p>
            </div>
            <div className={style.editButton}>
              {user.can_request_name_change ? <UpdateNameButton /> : null}
            </div>
          </section>
          <div className={style.separator} />
        </>
      )}
      <section>
        <div>
          <h4 className={style.subtitle}>Address</h4>
          <p className={style.noMarginBottom}>
            {noAddress ? 'No address' : addressLine1(user)}
          </p>
          <p className={style.noMarginTop}>{addressLine2(user)}</p>
        </div>
        <div className={style.editButton}>
          <UpdateAddressButton />
        </div>
      </section>
      <div className={style.separator} />
      <section>
        <div>
          <h4 className={style.subtitle}>Phone Number</h4>
          <p className={style.noMarginBottom}>
            {noPhone ? 'No phone' : formatPhone(user.phone, false)}
          </p>
        </div>
      </section>
    </Card>
  );
};

PersonalProfile.propTypes = {
  user: UserProps,
};

export default memo(PersonalProfile);
